import Cookies from 'js-cookie';

const insuranceQuoteRedirectCookie = 'openingInsuranceFromOPD';

const isAndroidWebView = () => {
  const ua = navigator?.userAgent;

  const isWebView = /CarvanaNativeWebView/gi.test(ua);
  const isAndroidOs = /Android/gi.test(ua);

  return isWebView && isAndroidOs;
};

export const determineInsuranceQuoteRedirect = referral => {
  const { providerName } = referral || {};
  const eligibleProvider = providerName?.toLowerCase() === 'root' || false;
  const isRedirectEligible = eligibleProvider && isAndroidWebView();

  if (!isRedirectEligible) {
    Cookies.remove(insuranceQuoteRedirectCookie);
  }
};

export const shouldRedirectToInsuranceQuote = () => {
  const redirectCookie = Cookies.get(insuranceQuoteRedirectCookie);
  const isRedirectEligible = (redirectCookie && isAndroidWebView()) || false;

  Cookies.remove(insuranceQuoteRedirectCookie);

  return isRedirectEligible;
};
